/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import '../style/expertise.css'
import business from '../images/business2.jpg'
import business2 from '../images/business3.jpg'
import business4 from '../images/business5.jpg'

const Expertices = () => {
    return (
        <>
            <section>
                <div className='container' style={{ marginTop: '25px' }} id='expCard'>
                    <h3 style={{ color: "#00415d", textAlign: 'center' }}>Business</h3>
                    <p style={{ marginTop: '25px', fontSize: '16px', textAlign: 'center' }}>We start by setting clear goals (visioning) and measuring progress (OKRs, KPIs). We also make sure everyone's on the same page (RASICs).But it's not just about plans, it's about your people too! We help businesses create a great work environment that keeps employees happy and productive (performance management, engagement & retention).</p>
                </div>
            </section>
            <section>
                <div className='container' style={{ marginTop: '30px' }} id='expCard'>
                    <div className='row' id='rowStoryFix'>
                        <div className='col-sm' id='colCard'>
                            <div className="card" style={{ width: "18rem", border: '0px' }}>
                                <img src={business} style={{ borderRadius: "0px" }} className="card-img-top" alt="business" />
                                <div className="card-body">
                                    <h6 className="card-title" style={{ color: '#00415d' }}>Operating Business Growth Plan</h6>
                                    <ul>
                                        <li style={{ color: '#737E86' }}>Idea Validation, Feasibility check</li>
                                    </ul>
                                    <a href="/ContactUs" >
                                        <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                            <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm' id='colCard'>
                            <div className="card" style={{ width: "18rem", border: '0px' }}>
                                <img src={business2} style={{ borderRadius: "0px" }} className="card-img-top" alt="business" />
                                <div className="card-body">
                                    <h6 className="card-title" style={{ color: '#00415d' }}>Business Scalability Assessment</h6>
                                    <ul>
                                        <li style={{ color: '#737E86' }}>Baseline Review / gap analysis of current business processes</li>
                                    </ul>
                                    <a href="/ContactUs" >
                                        <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                            <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm' id='colCard'>
                            <div className="card" style={{ width: "18rem", border: '0px' }}>
                                <img src={business4} style={{ borderRadius: "0px" }} className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <h6 className="card-title" style={{ color: '#00415d' }}>Strategic Partnering for Growth</h6>
                                    <ul>
                                        <li style={{ color: '#737E86' }}>Operational / Implementation Assistance</li>
                                    </ul>
                                    <a href="/ContactUs" >
                                        <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                            <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Expertices
